module.exports = "/images/Ball pits.svg?eb14af406b0232b52f00e9b989af937b";